/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  BankReadDataList
} from '../../model/bankReadDataList'
import type {
  BankUpsertAPIDataRequest
} from '../../model/bankUpsertAPIDataRequest'
import type {
  BanksListParams
} from '../../model/banksListParams'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Lists bank info
 */
export const banksList = (
    params?: BanksListParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<BankReadDataList>(
      {url: `/bank/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getBanksListQueryKey = (params?: BanksListParams,) => {
    return [`/bank/`, ...(params ? [params]: [])] as const;
    }

    
export const getBanksListQueryOptions = <TData = Awaited<ReturnType<typeof banksList>>, TError = unknown>(params?: BanksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof banksList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBanksListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof banksList>>> = ({ signal }) => banksList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof banksList>>, TError, TData> & { queryKey: QueryKey }
}

export type BanksListQueryResult = NonNullable<Awaited<ReturnType<typeof banksList>>>
export type BanksListQueryError = unknown

export const useBanksList = <TData = Awaited<ReturnType<typeof banksList>>, TError = unknown>(
 params?: BanksListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof banksList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getBanksListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getBanksListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof banksList>>, TError = unknown>(params?: BanksListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof banksList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBanksListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof banksList>>> = ({ signal }) => banksList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof banksList>>, TError, TData> & { queryKey: QueryKey }
}

export type BanksListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof banksList>>>
export type BanksListSuspenseQueryError = unknown

export const useBanksListSuspense = <TData = Awaited<ReturnType<typeof banksList>>, TError = unknown>(
 params?: BanksListParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof banksList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getBanksListSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getBanksListLoader = (queryParamsOrFn?: (BanksListParams | ((params: Params) => BanksListParams))): LoaderFunction =>
        authedLoader(({ params }) => {
          const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          return appQueryClient.prefetchQuery({
            queryKey: getBanksListQueryKey(queryParams),
            queryFn: () => banksList(queryParams),
          }).then(() => null);
        });
      /**
 * Upserts bank information in bulk
 */
export const banksBulkUpsert = (
    bankUpsertAPIDataRequest: BankUpsertAPIDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<BankReadDataList>(
      {url: `/bank/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bankUpsertAPIDataRequest
    },
      options);
    }
  


export const getBanksBulkUpsertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof banksBulkUpsert>>, TError,{data: BankUpsertAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof banksBulkUpsert>>, TError,{data: BankUpsertAPIDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof banksBulkUpsert>>, {data: BankUpsertAPIDataRequest}> = (props) => {
          const {data} = props ?? {};

          return  banksBulkUpsert(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type BanksBulkUpsertMutationResult = NonNullable<Awaited<ReturnType<typeof banksBulkUpsert>>>
    export type BanksBulkUpsertMutationBody = BankUpsertAPIDataRequest
    export type BanksBulkUpsertMutationError = unknown

    export const useBanksBulkUpsert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof banksBulkUpsert>>, TError,{data: BankUpsertAPIDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getBanksBulkUpsertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    